/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import Main from '../../../components/HOC/Main';
import Button from '../../../components/common/Button';
import { useLocation } from 'react-router-dom';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import { fetchSingleJobs } from '../../../store/slices/api/inner/jobsSlice';
import { selectSelectedJobs, setSelectedJobs } from '../../../store/slices/common';
import { useDispatch, useSelector } from 'react-redux';

export default function JobsDetailPage() {
  const location = useLocation();
  const job = location.state?.jobsData || {};
  const dispatch = useDispatch();
  const jobsData = useSelector(selectSelectedJobs)
  
 
  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchSingleJobs,
    setValueAction: setSelectedJobs,
    isForm: false,
    successMessage: false,
  });

  

  useEffect(() => {
    fetchData({
      job_id: job?.job_id
    });
    return () => {
      dispatch(setSelectedJobs(null))
    }
  }, [job?.job_id])
  

  return (
    <Main>
      <div className="font-sans">
        {/* Hero Section */}
        <section className="bg-gray-500 text-white text-center py-5 px-4">
          <div className="container mx-auto">
            <h1 className="text-3xl font-bold mb-4">{jobsData?.job_title}</h1>

            {/* New Information Display */}
            <p className="text-lg mb-2">Department: {jobsData?.inferred_department_name}</p>
            <p className="text-lg mb-2">Company: {jobsData?.company_name}</p>
            <p className="text-sm mb-2">Posted on: {new Date(jobsData?.post_date).toLocaleDateString()} | Last Date to Apply: {jobsData?.valid_through}</p>

            {/* Centering the buttons */}
            <div className="mt-8 flex justify-center space-x-4">
              <Button className="bg-white text-blue-500 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100">
                VIEW COMPANY
              </Button>
              <Button className="bg-white text-blue-500 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100">
                APPLY FOR THIS JOB
              </Button>
            </div>
          </div>
        </section>


        {/* About Us and Apply Section */}
        <section className="bg-gray-100 py-16 px-4">
          <div className="container mx-auto grid lg:grid-cols-1 gap-10 items-start">

            {/* About Section */}
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-bold mb-6">About this role</h2>
              <div className="flex items-start">
                {/* <img
                  src="https://via.placeholder.com/150"
                  alt="UX/UI Designer"
                  className="w-40 h-40 mr-6 rounded-sm"
                /> */}
                <div>
                  <h3 className="text-xl text-orange-600 font-bold">{jobsData?.inferred_job_title} ({jobsData?.job_type})</h3>
                  <p className="text-sm text-gray-600 mb-2 font-semibold">{jobsData?.company_name}</p>
                  <p className="text-sm text-gray-600"><b>Location : </b>{jobsData?.city} , {jobsData?.inferred_country}</p>
                  <p className="text-sm text-gray-600"><b>Level : </b>{jobsData?.inferred_seniority_level}</p>
                  <p className="text-sm text-gray-600"><b>Job Board : </b>{jobsData?.job_board}</p>
                  <p className="text-sm text-orange-600"><b>Remote :</b> {jobsData?.is_remote==='true' ? 'Yes' : 'No'}</p>
                  <p className="text-sm text-green-600 mb-5"><b>Expired :</b> {jobsData?.has_expired==='true' ? 'Yes' : 'No'}</p>
                  <hr />
                  {jobsData?.html_job_description ?
                    <div className="text-gray-700 mt-5 mb-4" dangerouslySetInnerHTML={{ __html: jobsData?.html_job_description ?? jobsData?.job_description }}></div>
                    :
                    <div className="text-gray-700 mt-5 mb-4">
                      {
                        jobsData?.job_description
                      }
                    </div>
                  }

                  <div className="flex flex-wrap gap-2">
                    {jobsData?.inferred_skills?.map((skill, index) => (
                      <span key={index} className="bg-blue-500 text-white px-3 py-1 rounded-full">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div >
    </Main >
  );
}
